"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withValidate", {
  enumerable: true,
  get: function get() {
    return _withValidate.default;
  }
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _webValidations = require("@mhub/web-validations");

var _common = require("../../common");

var _lib = require("../../lib");

var _withValidate = _interopRequireDefault(require("./withValidate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Validate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Validate, _PureComponent);

  function Validate(props) {
    var _this;

    _classCallCheck(this, Validate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Validate).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getValue", function (event, data) {
      if ((0, _lib.objHasOwnProperty)(data, 'value')) {
        return data.value;
      }

      return (0, _lib.getEventKey)(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleValidate", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var _this$props = _this.props,
          name = _this$props.name,
          label = _this$props.label,
          validateLabel = _this$props.validateLabel,
          validations = _this$props.validations,
          message = _this$props.message;
      var validateProps = {
        value: value,
        name: name,
        label: validateLabel || label,
        validations: validations,
        message: message
      };
      return (0, _webValidations.validate)(validateProps).then(function (result) {
        var key = result.key,
            isValid = result.isValid,
            rest = _objectWithoutProperties(result, ["key", "isValid"]); // ignore result.key


        _this.setState(_objectSpread({
          error: !isValid
        }, rest), function () {
          var onValidate = _this.props.onValidate;

          if (onValidate) {
            onValidate(result);
          }
        });

        return result;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, data) {
      (0, _lib.callEventMethods)(e, 'persist'); // get value

      var value = _this.getValue(e, data);

      _this.handleValidate(value).then(function () {
        _this.setState({
          value: value
        }, function () {
          // continue parent onChange
          var _this$props2 = _this.props,
              onChange = _this$props2.onChange,
              name = _this$props2.name;

          if (onChange) {
            onChange(e, {
              name: name,
              value: value
            });
          }
        });
      });
    });

    var _value = props.value,
        error = props.error;
    _this.state = {
      prevProps: {
        value: _value,
        error: error
      },
      // this only store props.value
      error: error,
      message: undefined,
      value: _value || props.defaultValue
    };
    return _this;
  }

  _createClass(Validate, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          label = _this$props3.label,
          validateLabel = _this$props3.validateLabel,
          validations = _this$props3.validations,
          onValidate = _this$props3.onValidate,
          onChange = _this$props3.onChange,
          rest = _objectWithoutProperties(_this$props3, ["children", "label", "validateLabel", "validations", "onValidate", "onChange"]);

      var _this$state = this.state,
          error = _this$state.error,
          message = _this$state.message;
      var child = (0, _lib.getRenderProps)(children, _objectSpread({
        value: this.state.value
      }, rest, {
        error: error,
        message: message,
        onChange: this.handleOnChange
      }));
      return _react.Children.only(child);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          error = props.error;
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          error: error
        },
        value: prevProps.value !== value ? value : state.value,
        error: prevProps.error !== error ? error : state.error
      };
    }
  }]);

  return Validate;
}(_react.PureComponent);

exports.default = Validate;

_defineProperty(Validate, "displayName", 'Validate');

_defineProperty(Validate, "propTypes", {
  value: _propTypes.default.oneOfType([_common.customPropTypes.stringOrNumber, _propTypes.default.array, _propTypes.default.object]),
  defaultValue: _propTypes.default.oneOfType([_common.customPropTypes.stringOrNumber, _propTypes.default.array, _propTypes.default.object]),
  children: _common.customPropTypes.render.isRequired,
  // validate
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  validateLabel: _propTypes.default.string,
  message: _propTypes.default.string,
  onValidate: _propTypes.default.func,
  validations: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    validate: _propTypes.default.func,
    options: _propTypes.default.object
  })]).isRequired),
  onChange: _propTypes.default.func,
  error: _propTypes.default.bool
});

_defineProperty(Validate, "defaultProps", {
  value: undefined,
  defaultValue: '',
  // validate
  name: null,
  label: null,
  validateLabel: null,
  message: undefined,
  validations: [],
  onValidate: null,
  onChange: null,
  error: false
});